/** @format */

import type { QueryClient } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import PageLoader from "./utils/PageLoader";

// Create router instance
// This router is used for both SSR and client-side rendering
export const router = createRouter({
  routeTree,
  context: {
    queryClient: undefined as unknown as QueryClient,
  },
  defaultPreload: "intent", // Prefetch on link hover
  defaultPreloadStaleTime: 0,
  defaultPendingComponent: () => <PageLoader />,
  defaultStructuralSharing: true, // Prevent unnecessary re-renders from router state changes
});

// Type augmentation for type-safe context
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Router provider component for client-side
export function TanStackRouterProvider() {
  const queryClient = useQueryClient();

  return <RouterProvider router={router} context={{ queryClient }} />;
}

// Router provider for SSR (accepts queryClient as prop)
export function TanStackRouterProviderSSR({
  queryClient,
}: {
  queryClient: QueryClient;
}) {
  return <RouterProvider router={router} context={{ queryClient }} />;
}
